import { Injectable } from '@angular/core';
import * as localForage from 'localforage';

@Injectable()
export class GetLocalForageConFigService {

    constructor() { }

    async getConfigLocalForage() {
      localForage.config({
        driver: localForage.INDEXEDDB,
        size: 1000 * 1024 * 1024,
        storeName: 'keyvaluepairs',
        version: 1.0,
        description: 'TOPOSonCLOUD',
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/getLocalForage.service.ts